import { store } from '../redux/store';
import { openSessionModal } from '../redux/user/user_actions';
import { getCookie } from '../utils/helper';
import { axiosInstance } from './apiSevices';
import { refreshTokenUrl } from './urls';

const { dispatch } = store;

export const interceptor = () => {
  axiosInstance.interceptors.response.use(
    (res) => res,
    async (err) => {
      const message = err.response?.data?.message;
      const status = err.response?.status;
      const originalRequest = err.config;

      // no token — attempt silent refresh
      if (message === 'No token provided.' && status === 403 && !originalRequest._retry) {
        originalRequest._retry = true;

        try {
          // get the refresh token cookie first
          const refreshToken = getCookie('refresh_token');
          // refresh token cookie sent automatically — empty body, withCredentials in config
          await axiosInstance.post(refreshTokenUrl, { refresh_token: refreshToken }, { withCredentials: true });

          // new access token cookie set automatically — retry original request
          return axiosInstance(originalRequest);
        } catch (refreshError) {
          // refresh token also expired or invalid — open session modal
          openSessionModal(dispatch);
          return Promise.reject(refreshError);
        }
      }

      // token expired
      if (message === 'Token expired.' && status === 403) {
        openSessionModal(dispatch);
      }

      // session expired or unauthorized
      if (message === 'Session has expired' || status === 401) {
        openSessionModal(dispatch);
      }

      return Promise.reject(err);
    },
  );
};
